import { MatchTileController } from "./match-tile.controller";
import "./match-tile.style.scss";

const matchTileDirective = function(): Record<string, any> {
	return {
		restrict: "E",
		template: require("./match-tile.template.html"),
		controller: MatchTileController,
		controllerAs: "mtc",
	};
};

export default matchTileDirective;